import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "bandejaNotificaciones",
    "notificaciones",
);

export default handleActions(reducers, initialState);
